import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-informe-clientes',
  templateUrl: './informe-clientes.component.html',
  styleUrls: ['./informe-clientes.component.css']
})
export class InformeClientesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
